import { api } from "./axios";

export const submitContactSubmission = (payload) =>
  api.post("/api/contact-submissions", payload).then((r) => r.data);

export const submitQuestionnaireStep = (payload) =>
  api.post("/api/questionnaire/step", payload, { keepalive: true }).then((r) => r.data);
